import { useMutation } from '@tanstack/react-query'

import { apiPostCallbackNaverpaySuccess } from '@/payment/api'
import type { NaverpaySuccessCallbackBody } from '@/payment/types'

interface MutationArgs {
  paymentId: number
  body: NaverpaySuccessCallbackBody
}

export const usePostCallbackNaverpaySuccess = () => {
  return useMutation({
    mutationFn: ({ paymentId, body }: MutationArgs) => apiPostCallbackNaverpaySuccess(paymentId, body),
  })
}
